import React, {Fragment} from 'react';
import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {labels} from '../../../../../../../util/utils';
import {entities} from '../../../../../../../util/uiconstants';
import {refreshUnrelatedItControls} from '../../../../../../../actions/ITControl/itcontrolaction';
import BodySpecialListItemNoDataPlaceholder from '../BodySpecialListItemNoDataPlaceholder';
import {openItControlModal, openItRiskModal} from '../CreateUpdateEntities/createUpdateEntities.utils';

function ISA315ItGCItRiskItemNoDataPlaceholder({bodyId, itRisk, openRelateModal, onCreateUpdate}) {
	let placeholderText = null;

	const dispatch = useDispatch();

	if (itRisk) {
		placeholderText = itRisk.hasNoITGC
			? labels.NoITGCForITRiskPlaceholder
			: labels.itProcessItRiskItRiskItgcRequiredPlaceholder;
	}

	const addExistingItGc = () => {
		openRelateModal({
			bodyId: bodyId,
			entityId: entities.ItControl,
			parentEntity: itRisk,
			selectedItemIds: itRisk.itControls ?? []
		});
	};

	function onNewItgcModalHide() {
		return dispatch(refreshUnrelatedItControls(bodyId));
	}

	const addNewItGc = () => {
		openItControlModal(
			itRisk.itProcessId,
			itRisk.itProcessName,
			itRisk.id,
			itRisk.itRiskName,
			onCreateUpdate,
			undefined,
			{
				onContainerHide: onNewItgcModalHide
			}
		);
	};

	const noItRisksIdentified = () => {
		openItRiskModal(itRisk.itProcessId, itRisk.itProcessName, onCreateUpdate, itRisk);
	};

	const onPlaceholderClickConfig = {
		noItRisksIdentified: noItRisksIdentified,
		newITGC: addNewItGc,
		existingITGC: addExistingItGc
	};

	return (
		<Fragment>
			<StyledISA315ItGCItRiskItemNoDataPlaceholder
				placeholderText={placeholderText}
				onPlaceholderClickConfig={onPlaceholderClickConfig}
				className={`${itRisk.hasNoITGC ? 'NoITGCForITRiskPlaceholder' : 'ITGCsNotIdentifiedRiskNoITGCs'}`}
			/>
		</Fragment>
	);
}

ISA315ItGCItRiskItemNoDataPlaceholder.propTypes = {
	itRisk: PropTypes.shape({
		hasNoITGC: PropTypes.bool
	})
};

export default ISA315ItGCItRiskItemNoDataPlaceholder;

const StyledISA315ItGCItRiskItemNoDataPlaceholder = styled(BodySpecialListItemNoDataPlaceholder)`
	background-color: unset;
	border: unset;
	padding: var(--px-10) var(--px-20);
	font-weight: 300;
	.no-data-placeholder {
		padding-bottom: var(--px-10);
		border-bottom: var(--px-1) solid var(--neutrals-200);
		a {
			font-weight: bold;
		}
	}
	&.ITGCsNotIdentifiedRiskNoITGCs {
		color: var(--neutrals-900);
		a {
			font-weight: bold;
		}
	}
	&.NoITGCForITRiskPlaceholder {
		font-style: italic;
		color: var(--neutrals-700);
	}
`;
